// https://communitiesauto.wixsite.com/const-performance
export const PERFORMANCE_TEST_SITE_MSID = '3b963e77-1ba4-463d-a51e-130297dd3676';
